import React from "react";

import { FinanceSubModalSection } from "constants/settings";
import { useSectionHelper, SectionToggleState } from "hooks";

import { ForLivestockAgent } from "containers/ForUserType";
import VendorCommissions from "../VendorCommissions/VendorCommissions";

interface BusinessInterestSectionProps {
  sectionHelper: SectionToggleState;
  namespace: string;
  businessId: string;
}

export const BusinessVendorCommissionSection: React.FC<
  BusinessInterestSectionProps
> = ({ sectionHelper, namespace, businessId }) => {
  const { isOpen, onToggle } = useSectionHelper(
    sectionHelper,
    FinanceSubModalSection.VENDOR_COMMISSION,
  );

  return (
    <ForLivestockAgent>
      <VendorCommissions
        isOpen={isOpen}
        onToggle={onToggle}
        namespace={namespace}
        businessId={businessId}
      />
    </ForLivestockAgent>
  );
};
